import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';

@Component({
  selector: 'app-success',
  standalone: true,
  imports: [TranslateDirective],
  templateUrl: './success.component.html',
  styleUrl: './success.component.less'
})
export class SuccessComponent {
  constructor( private router: Router){
    this.message = this.router.getCurrentNavigation()?.extras.state;
  }
  ngOnInit(){ 
  }

  message:any;

  goToDashboard(){
    this.router.navigate(['/app-list']);
  }
}
